import { memo } from 'react';

const Divider = memo(() => {
  return (
    <div className="relative h-px bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-30" />
  );
});

Divider.displayName = 'Divider';

export default Divider;
